<div *ngIf="isDataLoaded" [@creFadeInOut]>
  <app-expandable-panel [cardType]="true">
    <div class="cre-wig-weekly-competition-details-carousel-control">
      <div
        class="cre-wig-weekly-competition-details-carousel-control-button"
        (click)="previousWeek()"
      >
        <fa-icon [icon]="['fas', 'caret-left']"></fa-icon>
      </div>
      <span class="cre-wig-weekly-competition-details-title">
        Week of {{ weeklyCompetitionDetails[currentWeekIndex].weekStartDate | date: 'M-d' }}
      </span>
      <div class="cre-wig-weekly-competition-details-carousel-control-button" (click)="nextWeek()">
        <fa-icon [icon]="['fas', 'caret-right']"></fa-icon>
      </div>
    </div>
  </app-expandable-panel>
  <p-carousel
    [page]="currentWeekIndex"
    [numVisible]="1"
    [value]="weeklyCompetitionDetails"
    #weeklyCompetitionDetailsCarousel
  >
    <ng-template let-weeklyCompetitionDetail pTemplate="item">
      <app-expandable-panel [cardType]="true">
        <div
          class="cre-wig-weekly-competition-details-content"
          (swipeleft)="nextWeek()"
          (swiperight)="previousWeek()"
        >
          <!-- Matchup -->
          <section *ngIf="weeklyCompetitionDetail.fleetMatchup">
            <div class="cre-wig-weekly-competition-details-title">
              Matchup
              <ng-container *ngIf="weeklyCompetitionDetail.fleetMatchup.competingFleet == null">
                (Bye Week)
              </ng-container>
            </div>
            <app-fleet-scoreboard
              [awayCompetition]="weeklyCompetitionDetail.fleetMatchup.competingFleetCompetition"
              [awayFleet]="weeklyCompetitionDetail.fleetMatchup.competingFleet"
              [awayTeamLogo]="weeklyCompetitionDetail.fleetMatchup.competingFleetTeamLogo"
              [awayTieBreaker]="weeklyCompetitionDetail.fleetMatchup.competingFleetTieBreaker"
              [competitionHeader]="weeklyCompetitionDetail.fleetMatchup.competitionHeader"
              [competitionProgress]="weeklyCompetitionDetail.fleetMatchup.progress"
              [homeCompetition]="weeklyCompetitionDetail.fleetMatchup.fleetCompetition"
              [homeFleet]="weeklyCompetitionDetail.fleetMatchup.fleet"
              [homeTeamLogo]="weeklyCompetitionDetail.fleetMatchup.fleetTeamLogo"
              [homeTieBreaker]="weeklyCompetitionDetail.fleetMatchup.fleetTieBreaker"
              [showTieBreaker]="weeklyCompetitionDetail.fleetMatchup.usedTiebreaker"
              [winningFleet]="weeklyCompetitionDetail.fleetMatchup.winningFleet"
            >
              <app-fleet-competition-results
                [fleet]="weeklyCompetitionDetail.fleetMatchup.competingFleet"
                [weekStartDate]="weeklyCompetitionDetail.weekStartDate"
                away-information
              ></app-fleet-competition-results>
              <app-fleet-competition-results
                [fleet]="weeklyCompetitionDetail.fleetMatchup.fleet"
                [weekStartDate]="weeklyCompetitionDetail.weekStartDate"
                home-information
              ></app-fleet-competition-results>
            </app-fleet-scoreboard>
          </section>
        </div>
      </app-expandable-panel>
    </ng-template>
  </p-carousel>
</div>
